import React, {useRef, useState} from 'react';
import {X} from "react-feather";
import {postReportConversation} from "../../services/api/messaging";
import {MESSAGE_REPORT_MAX} from "../../services/constants/MaxLenght";

const ModalReportConversation = ({activeConversation, onHandleToggle, onReportSend}) => {
    const messageRef = useRef(null);
    const [reportMessage, setReportMessage] = useState('');

    async function handleReportSent() {
        const message = messageRef.current.value;
        if (!message) {
            messageRef.current.classList.add('sl-input-destructive');
        }

        const payload = {
            'message': message,
        };
        try {
            await postReportConversation(activeConversation.id, payload).then(() => {
                setReportMessage('');
                onHandleToggle();
                onReportSend(true);
            });
            onHandleToggle();
        } catch (error) {
            console.error('Error fetching messages:', error);
            onReportSend(false);
        }
    }

    const handleReportMessageChange = (event) => {
        const report = event.target.value;
        setReportMessage(report);

        if (report.length > MESSAGE_REPORT_MAX) {
            messageRef.current.classList.add('sl-input-destructive');
        } else {
            messageRef.current.classList.remove('sl-input-destructive');
        }
    }

    return (
        <div className="">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title"
                     className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    Report
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={onHandleToggle}>
                    <X/>
                </div>
            </div>

            <div className="sl-modal-body">
                <div className="sl-px-6 sl-pb-0 sl-pt-24">
                    <div className="sl-text-md sl-font-normal sl-text-gray-900">
                        Please inform Shortlister of the reason for reporting this conversation.
                    </div>
                    <div
                        className="sl-mt-6 sl-flex sl-flex-col sl-justify-start sl-w-fill-available sl-gap-1-point-5">
                            <textarea placeholder="" ref={messageRef} value={reportMessage}
                                      onChange={handleReportMessageChange}
                                      className="sl-input sl-modal-textarea sl-border-1 sl-shadow-xs sl-rounded-lg sl-font sl-font-normal sl-text-md sl-text-gray-base"
                                      required/>
                    </div>
                </div>
            </div>

            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button onClick={onHandleToggle}
                            className="sl-btn sl-btn-tertiary sl-btn-lg sl-rounded-lg">
                        Cancel
                    </button>
                    <button onClick={handleReportSent}
                            disabled={reportMessage === '' || reportMessage.length > MESSAGE_REPORT_MAX}
                            className="sl-btn sl-btn-primary sl-btn-lg sl-rounded-lg ">
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalReportConversation;
